import { useSimplesNacional } from '@/contexts/SimplesNacionalContext';
import { useHeader } from '@/contexts';
import type { SegregacaoCalcularPayload } from '@/services/SimplesNacional/Segregacao/api/types';

const MESES_PT: Record<string, string> = {
  Janeiro: '1',
  Fevereiro: '2',
  Março: '3',
  Abril: '4',
  Maio: '5',
  Junho: '6',
  Julho: '7',
  Agosto: '8',
  Setembro: '9',
  Outubro: '10',
  Novembro: '11',
  Dezembro: '12',
};

export function useSegregacaoFiltros(): SegregacaoCalcularPayload | null {
  const { cnpjContribuinte } = useSimplesNacional();
  const { filtros } = useHeader();
  const { periodoMes, periodoAno } = filtros;

  if (!cnpjContribuinte || !periodoMes || !periodoAno) return null;

  const mes = MESES_PT[periodoMes] ?? periodoMes;

  return {
    CnpjContribuinte: cnpjContribuinte,
    Ano: String(periodoAno),
    Mes: mes,
    RevisaoPropria: 'N',
    Recuperacao: 'S',
  };
}
